import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
import SignList from '@/views/SignList.vue'
import Callback from '@/views/Callback.vue'
import { isInWxWork, isInFeishu, redirectToQwAuth, redirectToFeishuAuth } from '@/utils/auth'
import { qwLogin, feishuLogin } from '@/api/sign'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'SignList',
      component: SignList
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    }
  ]
})

// 认证成功后清理 URL 中的 code/state 授权参数，避免刷新时重复消费授权码
function cleanAuthParams() {
  if (window.location.search.indexOf('code=') === -1) {
    return
  }
  const url = window.location.protocol + '//' + window.location.host + window.location.pathname
  window.history.replaceState({}, '', url)
}

/**
 * 登录鉴权：无 sign_token 时按访问渠道分流
 * 企业微信通道：企业微信内打开应用 URL 自带 OAuth code，前端直调后端 qw-login 换会话
 * 飞书通道：无 code 先跳飞书授权页，授权回跳带 code 直调后端 feishu-login 换会话
 * 其他环境（PC 浏览器等）：兜底走旧的企微 authorize 两跳登录（/callback 收 token）
 */
router.beforeEach(async (to, from, next) => {
  // /callback 为旧 authorize 两跳模式的 token 回跳页，直接放行
  if (to.path === '/callback') {
    next()
    return
  }

  const token = localStorage.getItem('sign_token')
  if (token) {
    next()
    return
  }

  const code = to.query.code

  if (isInWxWork()) {
    if (!code) {
      // 企微工作台直接打开主页 URL 不自动带 code，先跳一次企微授权链接换取 code 再回跳
      redirectToQwAuth()
      return
    }
    try {
      const res = await qwLogin({ code })
      if (res.code === 200 && res.token) {
        localStorage.setItem('sign_token', res.token)
        cleanAuthParams()
        next()
      } else {
        cleanAuthParams()
        Message.error((res && res.message) || '企业微信认证失败')
      }
    } catch (err) {
      cleanAuthParams()
      Message.error('企业微信认证失败')
    }
  } else if (isInFeishu()) {
    if (!code) {
      redirectToFeishuAuth()
      return
    }
    try {
      const res = await feishuLogin({ code, redirectUri: window.location.origin })
      if (res.code === 200 && res.token) {
        localStorage.setItem('sign_token', res.token)
        cleanAuthParams()
        next()
      } else {
        cleanAuthParams()
        Message.error((res && res.message) || '飞书认证失败')
      }
    } catch (err) {
      cleanAuthParams()
      Message.error('飞书认证失败')
    }
  } else {
    window.location.href = '/api/hfsign/oauth/authorize?redirect_uri=' + encodeURIComponent(window.location.origin + '/callback')
  }
})

export default router
